export const AGENCY_VIEW = 'real-estate-agencies';
export const AGENT_VIEW = 'real-estate-agents';

export const SEARCH_TYPE_OPTIONS = [
  { value: AGENCY_VIEW, label: 'Agencies' },
  { value: AGENT_VIEW, label: 'Agents' },
];
